import React, { useEffect, useMemo, useState } from 'react';
import { addResponseInterceptor, ejectResponseInterceptor } from '../api/base';
import { getUser, loginUser, getUserGoogle, logoutUser } from '../api/user';
import { BACKEND_URL } from '../config';
//import { useHistory } from "react-router-dom";
import storage from '../helpers/storage';

export const UserContext = React.createContext();

export const UserProvider = (props) => {
  const [user, setUser] = useState(storage.get('user'));
  const [error, setError] = useState(null);
  //const history = useHistory();

  // To intercept when jwt has expired
  useEffect(() => {
    const interceptor = addResponseInterceptor((res) => {
      if (res.status == 401) setError(res.data);
      return res;
    });

    return () => ejectResponseInterceptor(interceptor);
  }, []);

  /**
   * To check if the user stored in the localstorage is a valid user.
   * If someone access by url and the user stored into the localstorage
   * is not null. We must validate the user and whether it has a valid cookie
   */
  useEffect(() => {
    if (user)
      getUser(user.hash).then((res) => {
        if (!res?.success) setUser(null);
      });
  }, []);

  // If an error occurs then we clear the user
  useEffect(() => {
    if (error) setUser(null);
  }, [error]);

  // If the user is updated then we update the localstorage
  useEffect(() => {
    storage.set('user', user);
  }, [user]);

  function login(credentials) {
    setError(null);
    loginUser(credentials).then((res) => {
      //console.log("data login", res.data)
      if (res.success) setUser(res.data);
      else setError(res.error);
    });
  }

  const fetchAuthUser = async () => {
    //const response = getUserGoogle().then((res) => {
    getUserGoogle().then((res) => {
      //console.log("response: ", res);
      if (res.success) 
        setUser(res.data);
      else {
        setUser(null);
        setError(res.error);
      }
    });
  };

  const loginGoogle = async () => {
    let timer = null;
    const googleLoginURL = BACKEND_URL+"/users/login/google";
    const newWindow = window.open(
      googleLoginURL,
      "_blank",
      "width=500,height=600"
    );

    if (newWindow) {
      timer = setInterval(() => {
        if (newWindow.closed) {
          //console.log("authenticated with Google !!");
          fetchAuthUser();
          //history.push("/candidates");
          if (timer) clearInterval(timer);
        }
      }, 500);
    }
  };

  function logout() {
    logoutUser().then((res) => {
      console.log("logout", res.data)
    });
    setUser(null);
  }

  const options = useMemo(
    () => ({
      isUserLoggedIn: user !== null,
      user,
      error,
      login,
      loginGoogle,
      logout,
    }),
    [user, error]
  );

  return <UserContext.Provider value={options} {...props} />;
};
